export const SEND_MESSAGE = 'Chat/SEND_MESSAGE'
export const UPDATE_MESSAGE_STATUS = 'Chat/UPDATE_MESSAGE_STATUS'

export const FETCH_CONTACTS = 'Chat/FETCH_CONTACTS'
export const FETCH_CONTACTS_SUCCESS = 'Chat/FETCH_CONTACTS_SUCCESS'
export const PING_SERVER = 'Chat/PING_SERVER'

export const LISTEN_MY_DIALOGS = 'Chat/LISTEN_MY_DIALOGS'
export const STOP_LISTEN_MY_DIALOGS = 'Chat/STOP_LISTEN_MY_DIALOGS'
export const RESET_CHAT = 'Chat/RESET_CHAT'

export const CREATE_CHANNEL = 'Chat/CREATE_CHANNEL'
export const ADD_CHANNEL_MEMBERS = 'Chat/ADD_CHANNEL_MEMBERS'
export const CREATE_DIALOG = 'Chat/CREATE_DIALOG'
export const REMOVE_DIALOG = 'Chat/REMOVE_DIALOG'

export const SET_DIALOG = 'Chat/SET_DIALOG'
export const SET_ACTIVE_DIALOG = 'Chat/SET_ACTIVE_DIALOG'



// WEBPACK FOOTER //
// ./src/Reducers/Chat/const.js